// extracted by mini-css-extract-plugin
export var bodyRow = "_ec-d";
export var cardColumns = "_ec-e";
export var ellipsesOverflow = "_ec-2";
export var flatBottomCorners = "_ec-3";
export var flatTopCorners = "_ec-4";
export var headerActionsDropdown = "_ec-f";
export var headerBottomRow = "_ec-c";
export var headerTopRow = "_ec-b";
export var orderDetailsWrapper = "_ec-0";
export var orderInfoContainer = "_ec-1";
export var productDetails = "_ec-9";
export var productImage = "_ec-5";
export var responsiveTable = "_ec-8";
export var shipmentContainer = "_ec-a";
export var tableBottomLeft = "_ec-6";
export var tableBottomRight = "_ec-7";
export var trackingLink = "_ec-g";